import { useState, useEffect } from 'react'
import { auth, db } from '../../firebase'
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore'

const useMessages = (chatId) => {
  const [messages, setMessages] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const user = auth.currentUser

  useEffect(() => {
    if (!chatId || !user) { return }

    const messagesRef = collection(db, 'users', user.uid, 'chats', chatId, 'messages')
    const messagesQuery = query(messagesRef, orderBy('createdAt'))

    const unsubscribe = onSnapshot(
      messagesQuery,
      (snapshot) => {
        const fetchedMessages = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        }))
        setMessages(fetchedMessages)
        setLoading(false)
      },
      (err) => {
        console.error('Error fetching messages: ', err)
        setError(err)
        setLoading(false)
      }
    )
    // Clean up the listener on unmount or when chatId changes
    return () => unsubscribe()
  }
  , [chatId])

  return { messages, loading, error }
}

export default useMessages
